export enum RightBarActionType {
  SHOW_RIGHT_BAR = 'SHOW_RIGHT_BAR',
  HIDE_RIGHT_BAR = 'HIDE_RIGHT_BAR',
  FULL_SCREEN = 'FULL_SCREEN',
  COLLAPSE = 'COLLAPSE',
  HALF_SCREEN = 'HALF_SCREEN',
  HALF_SCREEN_COLLAPSE = 'HALF_SCREEN_COLLAPSE',
}
